import React from "react";
import tw from "twin.macro";
import {
  ChartBarIcon,
  UserGroupIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/24/outline";

const stats = [
  {
    title: "Total Users",
    value: "120",
    icon: <UserGroupIcon className="h-8 w-8 text-blue-500" />,
    bg: "bg-blue-100",
  },
  {
    title: "Total Donations",
    value: "₹35,000",
    icon: <CurrencyDollarIcon className="h-8 w-8 text-green-600" />,
    bg: "bg-green-100",
  },
  {
    title: "Monthly Visitors",
    value: "1,480",
    icon: <ChartBarIcon className="h-8 w-8 text-purple-600" />,
    bg: "bg-purple-100",
  },
];

const Container = tw.div`grid grid-cols-1 md:grid-cols-3 gap-6`;
const Card = tw.div`bg-white p-6 rounded-lg shadow flex items-center`;
const IconWrapper = tw.div`p-3 rounded-full mr-4`;

export default function Dashboard() {
  return (
    <div>
      <h2 tw="text-2xl font-bold mb-6 text-gray-800">Admin Dashboard</h2>
      <Container>
        {stats.map((stat, index) => (
          <Card key={index}>
            <IconWrapper className={stat.bg}>{stat.icon}</IconWrapper>
            <div>
              <p tw="text-sm text-gray-600">{stat.title}</p>
              <p tw="text-xl font-semibold text-gray-800">{stat.value}</p>
            </div>
          </Card>
        ))}
      </Container>
    </div>
  );
}
